import { z } from "zod";
import { ACCEPTED_FILE_TYPES, MAX_FILE_SIZE } from "../utils";


export const contactFormSchema = z.object({
      name: z.string().min(3),
      email: z.string().email(),
      message: z.string().min(10),
      files: z
            .custom<FileList>()
            .refine((files) => files?.length <= 3, "Maximum of 3 files")
            .refine(
                  (files) =>
                        Array.from(files || []).every(file => file.size <= MAX_FILE_SIZE),
                  "Each file must be less than 1MB"
            )
            .refine(
                  (files) =>
                        Array.from(files || []).every(file => ACCEPTED_FILE_TYPES.includes(file.type)),
                  "Only .jpg, .png, and .pdf files are accepted"
            )
            .optional(),
});

export type ContactFormData = z.infer<typeof contactFormSchema>